'use client'
import { useState } from 'react'
import dynamic from 'next/dynamic'
import { getCookie } from 'helpers/cookies'
import { Modal } from 'antd'
import { Button } from 'app/(new-pages)/components/Button/pc/index.pc'
import styles from '../../../../index.module.scss'

const GoogleMap = dynamic(() => import('components/GoogleMap/GoogleMap'), {
  ssr: false
})
const Client = ({ data, mapModalTitle, done }) => {
  const [open, setOpen] = useState(false)
  const { latitude, longitude, distance, address } = data ?? {}
  const userInfo = getCookie('user') || {}
  const handleMapLayer = (e) => {
    const isMenuBar = document.querySelector('[role=menubar]')?.contains(e.target)
    if (!isMenuBar) {
      setOpen(true)
    }
  }
  if (!data?.latitude && !data?.longitude) return null

  return (
    <>
      {!isNaN(latitude) && !isNaN(longitude) ? (
        <>
          {userInfo?.latitude && distance && <p className={styles.mapDistance}>{distance}</p>}
          <div className={styles.map_context} onClick={handleMapLayer}>
            <GoogleMap
              lat={parseFloat(latitude)}
              lng={parseFloat(longitude)}
              gestureHandling='none'
              zoomControl={false}
              fullscreenControl={false}
              streetViewControl={false}
              clickable={false}
              infoWindow={address ?? ''}
            />
          </div>
        </>
      ) : null}
      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        width={700}
        wrapClassName={styles.wrapMapClass}
        centered
        title={mapModalTitle}
        footer={null}
      >
        <div className={styles.mapBox} id='googleMapSoaWAErd4'>
          {latitude && longitude && (
            <GoogleMap
              id='googleMapSoaWAErd4'
              lat={parseFloat(latitude)}
              lng={parseFloat(longitude)}
              gestureHandling='auto'
              zoomControl={true}
              fullscreenControl={true}
              streetViewControl={true}
              clickable={true}
              infoWindow={address}
            />
          )}
        </div>
        <div className={styles.button}>
          <Button btnSize='size40' onClick={() => setOpen(false)}>
            {done}
          </Button>
        </div>
      </Modal>
    </>
  )
}

export default Client
